var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBioTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "75mm",
    height: "75mm",
    viewBox: "0 0 212.6 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40.73,66.94A2.26,2.26,0,0,1,43,64.68H69.08c14.53,0,24.41,9.41,24.41,21.91,0,9.18-6.07,15.85-11.67,19.06,6.31,2.62,14.29,8.46,14.29,19.42,0,13.34-10.6,23-26,23H43a2.26,2.26,0,0,1-2.26-2.26ZM71.1,140.07a14.68,14.68,0,0,0,15-15.12c0-8.46-7.74-14.65-17-14.65H49.42v29.77Zm-2-38c9.17,0,14.29-6.55,14.29-14.89,0-8.58-5.12-14.29-14.29-14.29H49.66v29.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.27,72.78a5.66,5.66,0,1,1,5.59,5.59A5.62,5.62,0,0,1,108.27,72.78Zm1.66,29.89a2.34,2.34,0,0,1,2.27-2.26h3.69a2.34,2.34,0,0,1,2.26,2.26v43.12a2.34,2.34,0,0,1-2.26,2.26H112.2a2.34,2.34,0,0,1-2.27-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.31,99.22c13.23,0,23.71,11.43,23.71,24.89,0,13.7-10.48,25.14-23.71,25.14s-23.7-11.44-23.7-25.14C131.61,110.65,142.09,99.22,155.31,99.22Zm0,42.28c8.7,0,15.49-7.74,15.49-17.39,0-9.41-6.79-17-15.49-17s-15.48,7.62-15.48,17C139.83,133.76,146.62,141.5,155.31,141.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioTag);
export default __webpack_public_path__ + "static/media/BioTag.3c9af16384da5c4fa204dc29e3ebd906.svg";
export { ForwardRef as ReactComponent };